import { render } from "./InputField.vue?vue&type=template&id=21f85064"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"
script.render = render

export default script